import { inject, Injectable } from '@angular/core';
import { createBreadcrumbLabel } from '@capital-access/common/breadcrumbs';
import { LocalizationService } from '@capital-access/common/localization';
import { PENDO_SCOPE } from './constant';
import { PendoPortalPageComponent } from './pendo-portal-page.component';

@Injectable()
export class Breadcrumbs {
  readonly localizationScope = PENDO_SCOPE;
  private localizationService = inject(LocalizationService);

  feedbackPortal = createBreadcrumbLabel({ component: PendoPortalPageComponent }, () =>
    this.localizationService.localize('feedbackPortal', {}, this.localizationScope)
  );
}
